import { connect } from 'react-redux';
import React, { Component } from 'react';
import {Link, browserHistory} from 'react-router';
import imm from 'immutable';

import {http_methods} from '../utils';
import {
  TreeNavMenuItem,
  TreeNavMenu,
  TreeNavNodes
} from 'react-fe-bootstrap';
import MethodBadge from './MethodBadge';

class DocsRouteTree extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const self = this;
    const {spec, path, text, depth = 0, ...others} = this.props;
    if (!spec) {
      return null;
    }
    const label_text = text || path;

    if (!spec.keySeq) {
      return null;
    }
    const children = spec.keySeq().toJS().filter(key => /^\//.test(key)).map(key => {
      const new_path = path + key;
      return <DocsRouteTree role="menuItem" key={new_path} text={key} spec={spec.get(key)} path={new_path} depth={depth + 1}/>;
    });

    let operations = [];
    try {
      operations = spec.get('methods', imm.fromJS({})).keySeq().toJS().filter(op => http_methods[op]).reverse();
    }
    catch(err) {
      // TODO: handle any immutable.js errors
    }
    let link = '/'+path.split('/').slice(2).join('/');

    if(children.length === 0) {
      return <TreeNavMenuItem {...this.props}>
              <a role="link" className="nav-tree__link" href={'#'+link}>{label_text}</a>
              <span className="nav-tree__badges">
                {operations.map(op => <MethodBadge key={op} method={op} href={'#'+link+'-'+op}/>)}
              </span>
          </TreeNavMenuItem>
    } else {
      return <TreeNavMenu {...this.props} role="menuItem">
          <TreeNavMenuItem role="root">
              <a role="link" href={'#'+link}>{label_text}</a>
              <span className="nav-tree__badges">
                {operations.map(op => {
                  return <MethodBadge key={op} method={op} href={'#'+link+'-'+op}/>
                })}
              </span>
          </TreeNavMenuItem>
          <TreeNavNodes role="menu">
             {children}
          </TreeNavNodes>
      </TreeNavMenu>;
    }
  }
}

export default DocsRouteTree;
